import React from 'react'
import { useHistory } from 'react-router-dom'

import { ReactComponent as KeypadIcon } from 'assets/svg/dialpad/keypad.svg'
import { ReactComponent as BackSrcIcon } from 'assets/svg/shared/back.svg'

export function PageHeaderWithButtons({ pageName, backUrl, toggleKeypad, backHandler, onHideModal }) {
    const history = useHistory()

    function onGoBackHandler() {
        onHideModal && onHideModal()
        if (backHandler) {
            backHandler()
        } else if (backUrl) {
            history.push(backUrl)
        } else {
            history.goBack()
        }
    }
    return (
        <div className="app__page-header d-flex justify-content-center">
            <button type="button" onClick={onGoBackHandler} className="app__page-header__back">
                <BackSrcIcon />
            </button>
            {pageName}
            {toggleKeypad && (
                <button
                    type="button"
                    onClick={toggleKeypad}
                    className="app__page-header__back app__page-header__keypad"
                >
                    <KeypadIcon className="app__page-header__keypad-ico" />
                </button>
            )}
        </div>
    )
}
